
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NavBar from '../NavBar';
import Footer from '../Footer';
import MapPicker from "../Map/MapPicker";

import { useAuth } from '../../Authen/AuthContext'; // ปรับ path ตามโฟลเดอร์จริง


function CreatePropertyPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [latLng, setLatLng] = useState({ lat: 7.8806, lng: 98.3923 });
  const { user } = useAuth(); // ใช้ hook ดึง user
  const [property, setProperty] = useState({
    user_id: user?.id || '', 
    name: '',
    price: '',
    location: '',
    type: 'Condo',
    status: 'Buy',
    description: '',
    images: [],
    youtubeurl: '',
    bedrooms: '',
    bathrooms: '',
    featured: false,
    swimmingPool: '',
    buildingArea: '',
    landArea: '',
    ownership: '',
    constructionStatus: '',
    floors: '',
    furnished: false,
    parking: '',
    remark: ''
  });

  // ฟิลด์ที่ต้องกรอก
  const requiredFields = [
    { field: 'name', label: t('Property Name') },
    { field: 'price', label: t('Price') },
    { field: 'location', label: t('Location') },
    { field: 'type', label: t('Type') },
    { field: 'status', label: t('Status') },
    { field: 'images', label: t('Images') },
    { field: 'ownership', label: t('Ownership') },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProperty({
      ...property,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setProperty({
      ...property,
      images: files,
    });
  };

  const handlePriceChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, '').trim();
    const numberValue = Number(rawValue);
    setProperty({
      ...property,
      price: isNaN(numberValue) ? '' : numberValue,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    requiredFields.forEach(({ field, label }) => {
      if (
        (field === 'images' && property.images.length === 0) ||
        (!property[field] && field !== 'images')
      ) {
        newErrors[field] = `${label} ${t('is required')}`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    Object.keys(property).forEach((key) => {
      if (key === 'images') {
        property.images.forEach((image) => {
          formData.append('images', image);
        });
      } else {
        formData.append(key, property[key]);
      }
    });
formData.append('latitude', latLng.lat);
formData.append('longitude', latLng.lng);
    fetch('https://summerhousagentlive.onrender.com/api/properties', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        alert(t('Property added successfully'));
        setProperty({
          user_id: user?.id || '',
          name: '',
          price: '',
          location: '',
          type: 'Condo',
          status: 'Buy',
          description: '',
          images: [],
         
          bedrooms: '',
          bathrooms: '',
          featured: false,
          swimmingPool: '',
          building_area: '',
          landArea: '',
          ownership: '',
          constructionStatus: '',
          floors: '',
          furnished: false,
          parking: '',
        });
        setLatLng({ lat: null, lng: null });
      setErrors({});
        setErrors({});
      })
      .catch((error) => console.error('Error adding property:', error));
  };

  const locations = [
      "Talat Yai", "Talat Nuea","Koh Kaew", "Ratsada", "wichit", "Chalong",
  "Rawai", "Karon", "Kathu", "Patong", "Kamala", "Thep Krasatti",
  "Srisunthorn", "Cherng Talay", "Paklok", "Mai Khao", "Sakhu",
  ];

  return (
    <div style={styles.pageContainer}>
      <NavBar />
      <div style={styles.container}>
        <h2 style={styles.heading}>{t('Create New Property')}</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
     
       <p style={{ color: 'red', margin: 0, fontSize: '14px' }}>
         {t('Property Name * is required')} 
       </p>

          {/* Name */}
          <input
            type="text"
            name="name"
            value={property.name}
            onChange={handleChange}
            placeholder={t('Property Name')}
            style={{
              ...styles.input,
              borderColor: errors.name ? 'red' : '#ddd',
            }}
          />
          {errors.name && <div style={styles.error}>{errors.name}</div>}

          {/* Price */}
          <p style={{ color: 'red', margin: 0, fontSize: '14px' }}>
               {t('Price * is required')} 
          </p>
            
          <input
            type="text"
            name="price"
            value={property.price ? property.price.toLocaleString() : ''}
            onChange={handlePriceChange}
            placeholder={t('Price')}
            style={{
              ...styles.input,
              borderColor: errors.price ? 'red' : '#ddd',
            }}
          />
          {errors.price && <div style={styles.error}>{errors.price}</div>}

          {/* Location */}
          {/* Location */}
          <p style={{ color: 'red', margin: 0, fontSize: '14px' }}>
               {t('Location * is required')} 
          </p>
          <div>
            <select
              name="location"
              value={property.location}
              onChange={handleChange}
              style={{
                ...styles.select,
                borderColor: errors.location ? 'red' : '#ddd',
              }}
            >
              <option value="">{t('Select Location *')}</option>
              {locations.map((location, index) => (
                <option key={index} value={location}>
                  {t(location)}
                </option>
              ))}
              <option value="custom">{t('Other (please specify)')}</option>
            </select>
            {errors.location && <div style={styles.error}>{errors.location}</div>}

            {/* ถ้าเลือก Other ให้โชว์ input */}
            {property.location === 'custom' && (
              <input
                type="text"
                name="customLocation"
                value={property.customLocation || ''}
                onChange={(e) =>
                  setProperty({ ...property, customLocation: e.target.value })
                }
                placeholder={t('Enter custom location')}
                style={{
                  ...styles.input,
                  marginTop: '10px',
                  borderColor: errors.customLocation ? 'red' : '#ddd',
                }}
              />
            )}

  <div style={styles.guideText}>{t('Select from the list or type your own location.')}</div>
</div>

          {errors.location && <div style={styles.error}>{errors.location}</div>}
       

        <MapPicker
          initialLat={latLng.lat ?? 7.8806}
          initialLng={latLng.lng ?? 98.3923}
          onChange={(coords) => setLatLng(coords)}
        />
        <p style={{ fontSize: '12px', color: '#555', marginTop: '5px' }}>
            {t('Latitude')}: {latLng.lat ?? '-'}, {t('Longitude')}: {latLng.lng ?? '-'}
          </p>

     



          {/* Type */}
          <select name="type" value={property.type} onChange={handleChange} style={styles.select}>
            <option value="Condo">{t('Condo')}</option>
            <option value="House">{t('House')}</option>
            <option value="Pool Villa/ Villa">{t('Pool Villa/ Villa')}</option>
            <option value="Land">{t('Land')}</option>
            <option value="Warehouse/Factory/Business">{t('Warehouse / Factory / Business')}</option>
            <option value="Commercial Building">{t('Commercial Building')}</option>
          </select>

          {/* Status */}
          <select name="status" value={property.status} onChange={handleChange} style={styles.select}>
            <option value="Buy">{t('Buy')}</option>
            <option value="Rent">{t('Rent')}</option>
            
          </select>

          {/* Description */}
          <textarea
            name="description"
            value={property.description}
            onChange={handleChange}
            placeholder={t('Description')}
            style={styles.textarea}
          />
          <p style={{ color: 'red', margin: 0, fontSize: '14px' }}>
              {t('Images * is required')} 
          </p>
          {/* Images */}
          <input type="file" multiple onChange={handleImageChange} style={styles.input} />
          {errors.images && <div style={styles.error}>{errors.images}</div>}

          {/* YouTube URL */}
          <input
            type="text"
            name="youtubeurl"
            value={property.youtubeurl}
            onChange={handleChange}
            placeholder={t('YouTube Video URL')}
            style={styles.input}
          />
          <div style={{ fontSize: '12px', color: '#7F8C8D', marginTop: '-10px' }}>
            {t('Add a YouTube video link to showcase your property (optional)')}
          </div>

          {/* Bedrooms */}
          <input
            type="number"
            name="bedrooms"
            value={property.bedrooms}
            onChange={handleChange}
            placeholder={t('bedrooms')}
            style={styles.input}
          />

          {/* Bathrooms */}
          <input
            type="number"
            name="bathrooms"
            value={property.bathrooms}
            onChange={handleChange}
            placeholder={t('bathrooms')}
            style={styles.input}
          />

          {/* Floors */}
          <input
            type="number"
            name="floors"
            value={property.floors}
            onChange={handleChange}
            placeholder={t('Floors')}
            style={styles.input}
          />

          {/* Parking */}
          <input
            type="number"
            name="parking"
            value={property.parking}
            onChange={handleChange}
            placeholder={t('parking')}
            style={styles.input}
          />


          {/* Building Area */}
          <input
            type="text"
            name="buildingArea"
            value={property.buildingArea}
            onChange={handleChange}
            placeholder={t('Area')}
            style={{
              ...styles.input,
              borderColor: errors.buildingArea ? 'red' : '#ddd',
            }}
          />
          {errors.buildingArea && <div style={styles.error}>{errors.building_area}</div>}
             <textarea
              name="swimmingPool"
              value={property.swimmingPool}
              onChange={handleChange}
              placeholder={t('Swimming Pool')}
              style={styles.textarea}
            />

        {/*   Land Area 
          <input
            type="text"
            name="landArea"
            value={property.landArea}
            onChange={handleChange}
            placeholder={t('Land Area')}
            style={styles.input}
          />  */}

          {/* Ownership */}
          {/* Ownership */}
         <p style={{ color: 'red', margin: 0, fontSize: '14px' }}>
             {t('Ownership * is required')} 
          </p>
        <textarea
          name="ownership"
          value={property.ownership}
          onChange={handleChange}
          placeholder={t('Ownership *')}
          style={{
            ...styles.textarea,
            borderColor: errors.ownership ? 'red' : '#ddd',
            width: '100%',        // ให้เต็มบรรทัด
            minHeight: '80px',    // กำหนดความสูงเริ่มต้น
            resize: 'vertical'    // ให้ยืดขยายเฉพาะแนวตั้ง
          }}
        />
        {errors.ownership && <div style={styles.error}>{errors.ownership}</div>}

          {/* Contact Info 
          <input
            type="text"
            name="contactInfo"
            value={property.contactInfo}
            onChange={handleChange}
            placeholder={t('Contact Info *')}
            style={{
              ...styles.input,
              borderColor: errors.contactInfo ? 'red' : '#ddd',
            }}
          />
          {errors.contactInfo && <div style={styles.error}>{errors.contactInfo}</div>}*/}

            {/* Remark */}
            <textarea
              name="remark"
              value={property.remark}
              onChange={handleChange}
              placeholder={t('Remark')}
              style={styles.textarea}
            />
                {/* Remark */}
         


          {/* Construction Status */}
          <select name="constructionStatus" value={property.constructionStatus} onChange={handleChange} style={styles.select}>
          <option value="">{t('Select Construction Status')}</option>
              <option value="Under Construction/Under Renovation">{t('Under Construction / Under Renovation')}</option>
              <option value="Ready to Move In">{t('Ready to Move In')}</option>
              <option value="Pre-sale / Off-plan">{t('Pre-sale / Off-plan')}</option>
                <option value="As is house">{t('As is house')}</option>     </select>

          {/* Furnished */}
          <label>
            <input
              type="checkbox"
              name="furnished"
              checked={property.furnished}
              onChange={handleChange}
            /> {t('Furnished')}
          </label>

        

          {/* Featured */}
          <label>
            <input
              type="checkbox"
              name="featured"
              checked={property.featured}
              onChange={handleChange}
            /> {t('Hot Deal')}
          </label>

          <button type="submit" style={styles.button}>{t('Submit')}</button>
        </form>

        <button onClick={() => navigate('/')} style={styles.backButton}>
          {t('Back to Home')}
        </button>
      </div>
      <Footer />
    </div>
  );
}


const styles = {
  pageContainer: {
   display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '100vh',
  },
  container: {
    flex: 1,
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
    boxSizing: 'border-box',
  },
  heading: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
  },
  input: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  select: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  textarea: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    height: '100px',
    boxSizing: 'border-box',
  },
  button: {
    padding: '12px 20px',
    backgroundColor: '#2980B9',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  backButton: {
    marginTop: '20px',
    padding: '12px 20px',
    backgroundColor: '#3498db',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  propertyInfo: {
    fontSize: '14px',
    color: '#7F8C8D',
    marginBottom: '10px',
  },
  error: {
    color: 'red',
    fontSize: '12px',
    marginTop: '5px',
  },
  guideText: {
    fontSize: '12px',
    color: '#7F8C8D',
    marginTop: '5px',
    fontStyle: 'italic',
  },
};
export default CreatePropertyPage;
